async function AddAction(mutationName, data) {
  try {
    // Check if data contains formData for word by word transcription
    if (data.formData) {
      const res = await mutationName({ body: data.formData });
      return res;
    } else {
      const res = await mutationName({ body: data });
      return res;
    }
  } catch (error) {
    console.log({ addError: error });
    return error;
  }
}

export default AddAction;
